import { Box } from "@mui/material";
import {
  ArrayInput,
  BooleanInput,
  Create,
  NumberInput,
  required,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  useDataProvider,
} from "react-admin";
import { FieldValues } from "react-hook-form";
import {
  finlandCommunicationAssetLevelChoices,
  finlandCommunicationDirectionChoices,
  finlandCommunicationFieldTypeChoices,
  finlandCommunicationServiceOperatorChoices,
} from "shared/enums/reactAdminChoices";
import { FinlandCommunicationResourcesEnum } from "shared/enums/resourceMappings";

const ConfigProtocolParametersCreate = () => {
  const dataProvider = useDataProvider();
  const handleSubmit = (values: FieldValues) => {
    const { create_associated_configs, ...data } = values;
    dataProvider.create(FinlandCommunicationResourcesEnum.ConfigProtocolParameters, {
      data,
      meta: {
        urlParams: create_associated_configs,
      },
    });
  };

  return (
    <Create>
      <SimpleForm onSubmit={handleSubmit}>
        <BooleanInput source="create_associated_configs" />

        <ArrayInput source="configs">
          <SimpleFormIterator>
            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 2 }}>
              <SelectInput
                source="service_operator"
                choices={finlandCommunicationServiceOperatorChoices}
                validate={required()}
              />
              <SelectInput source="asset_level" choices={finlandCommunicationAssetLevelChoices} validate={required()} />
              <SelectInput source="direction" choices={finlandCommunicationDirectionChoices} validate={required()} />
              <NumberInput source="protocol_config_id" label="Protocol Config ID" validate={required()} />
              <NumberInput source="address" validate={required()} />
              <NumberInput source="asset_id" label="Asset ID" validate={required()} />
              <TextInput source="metric" validate={required()} />
              <SelectInput source="field_type" choices={finlandCommunicationFieldTypeChoices} />
              <NumberInput source="range_min" />
              <NumberInput source="range_max" />
            </Box>
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Create>
  );
};

export default ConfigProtocolParametersCreate;
